import transformerRegistry from '../registries/transformerRegistry';
import linkEventsRegistry from '../registries/linkEventsRegistry';
import { sendUtagLink } from './sendEvent';

const createEventListener =
  (dataLayer: object) =>
  <EventDataInterface>(message: string, data: EventDataInterface) => {
    let transformedData = {};
    const transformedMessage = linkEventsRegistry[message];
    if (transformerRegistry[message]) {
      transformedData = transformerRegistry[message](data);
      sendUtagLink(transformedMessage, dataLayer, transformedData);
    } else {
      sendUtagLink(transformedMessage, dataLayer, data);
    }
  };

export default createEventListener;
